export const getOpenedPaletteItem = state => state.palette.openedItem
